import ContactSelect from '@/generated/controls/contact/ContactSelect.vue';
import { defineComponent } from "vue";
import ListData, {ListFilter} from "@/extend/classes/ListData.ts";
import Contact from "@/extend/classes/Contact.ts";
import {ColumnFilter, ListChoix} from "@/generated/classes/ListData.ts";

export default defineComponent({
    components: {},
    extends: ContactSelect,
    methods: {
        loadData() {
            this.reset = this.toggleReset;
            const filter = this.commercialFilter();
            Contact.list(filter)
                .then((data: ListData) => {
                    this.listContact = data.reccords as Contact[];
                    this.listUpdated = true;
                }).catch(() => {
                //Catch empty list
            });
        },
        commercialFilter(): ListFilter {
            const res = new ListFilter();
            const columnFilter = new ColumnFilter();
            columnFilter.name = "clientId";
            columnFilter.staticFilter = true;
            const choix = new ListChoix();
            choix.value = 0;
            columnFilter.filters.push(choix);
            res.columnsFilter.push(columnFilter);
            return res;
        }
    },
})
